import dayjs from 'dayjs';
import 'dayjs/locale/ja';

dayjs.locale('ja');

export const addMinute = (time: string, addCount: number) => {
  return dayjs(`${'2021-01-01'}T${time}`).add(addCount, 'minute').format('HH:mm');
};

export default addMinute;
